<script>
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  computed: {
    ...mapGetters({
      uiFlags: 'notifications/getUIFlags',
    }),
  },
};
</script>

<template>
  <div class="acl-vazio-chat">
    <div v-if="uiFlags.isFetching" class="flex justify-center my-4">
      <Spinner class="text-n-brand" />
    </div>
    <section
      v-else
      class="acl-empty-conversation-state"
      aria-labelledby="acl-inbox-empty-state-title"
    >
      <div class="acl-empty-conversation-state__illustration">
        <img
          class="m-4 w-32 block dark:hidden"
          src="dashboard/assets/images/no-chat.svg"
          alt="No Chat"
        />
      </div>
      <h2
        id="acl-inbox-empty-state-title"
        class="acl-empty-conversation-state__title"
      >
        {{ $t('INBOX.LIST.SELECT_NOTIFICATION') }}
      </h2>
      <p class="acl-empty-conversation-state__description">
        {{ $t('INBOX.LIST.SELECT_NOTIFICATION_DESCRIPTION') }}
      </p>
    </section>
  </div>
</template>
